import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import * as actions from './orderStatusActions';
import { withFirebase } from '../Firebase';
import OrderStatus1 from './components/OrderStatus1';
import OrderStatus2 from './components/OrderStatus2';
import OrderStatus3 from './components/OrderStatus3';
import moment from 'moment';
import {
  ORDER_COMPLETE,
  ORDER_DELIVERED,
  ORDER_REJECTED,
  ORDER_REFUNDED,
} from './orderStatusTypes';
import flattenProduct from '../../utils/flattenProduct';
import appConfig from '../../../app-config';

let OrderStatusContainer = ({
  orderHistory,
  firebase,
  orderStatusList,
  loadOrderStatus,
  removeAllOrderStatus,
  removeOrderStatus,
  sendReview,
  feedbackModalIsVisible,
  openFeedbackModal,
  closeFeedbackModal,
  orderSettingReducer,
  isGuestSession,
  cartReducer,
  isAuthenticated,
  is_tip_enabled,
  locations,
}) => {
  const isGuestPlacedOrder = isGuestSession && placedOrder?.length;
  const [orderStatusModalData, setOrderStatusModalData] = useState(null);
  const { placedOrder, guestOrder } = cartReducer;
  const { interOrderType } = orderSettingReducer;
  const [timeList, setTimeList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isFavoriteOpen, setIsFavoriteOpen] = useState(false);
  const [feedbackModalData, setFeedbackModalData] = useState(null);
  const [displayComplete, setDisplayComplete] = useState(false);
  useEffect(() => {
    return () => {
      firebase.removeListeners();
      removeAllOrderStatus();
    };
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [orderStatusModalData]);
  useEffect(() => {
    // start fresh by clearing all listners and statuses
    firebase.removeListeners();
    removeAllOrderStatus();
    // listen to each order
    orderHistory
      .filter(
        (order) =>
          order.config_products &&
          order.config_products.length &&
          order?.firebase_uri
      )
      .forEach((order) => {
        if (order.firebase_uri) {
          firebase.listen(order.firebase_uri, (orderStatus) => {
            if (orderStatus.config_product) {
              const formattedOrderStatus = formatOrderStatus(orderStatus);
              if (orderStatusIsValid(formattedOrderStatus))
                loadOrderStatus(formattedOrderStatus);
            } else {
              // how to handle this case?
            }
          });
        } else {
          orderStatusIsValidNoFirebase(order)
            ? loadOrderStatus({
                orderId: order.order_id,
                config_product: [...order.config_products],
                order_created_at: order.order_created_at,
              })
            : removeOrderStatus(order);
        }
      });
  }, [orderHistory]);
  const updateTimeAndCompleted = useCallback(() => {
    let newTimeList = [];
    orderStatusList.forEach((order, index) => {
      if (timeList[index] && timeList[index].orderId === order.orderId) {
        newTimeList.push({
          orderId: order.orderId,
          completionTimerStartedAt: timeList[index].completionTimerStartedAt,
          displayComplete: timeList[index].displayComplete,
        });
      } else {
        newTimeList.push({
          orderId: order.orderId,
          completionTimerStartedAt: '',
          displayComplete: false,
        });
      }
    });
    setTimeList(newTimeList);
    setIsOpen(false);
  }, [orderStatusList]);

  useEffect(() => {
    updateTimeAndCompleted();
  }, [updateTimeAndCompleted]);
  const StatusCardLayout = ({ statusCardLayout }) => {
    switch (statusCardLayout) {
      case 1:
        return (
          <OrderStatus1
            orderStatusList={orderStatusList}
            sendReview={sendReview}
            feedbackModalIsVisible={feedbackModalIsVisible}
            openFeedbackModal={openFeedbackModal}
            closeFeedbackModal={closeFeedbackModal}
            currency={orderStatusList[0].currency}
            is_tip_enabled={is_tip_enabled}
            orderHistory={orderHistory}
            isGuestPlacedOrder={isGuestPlacedOrder}
            placedOrder={placedOrder}
            interOrderType={interOrderType}
            timeList={timeList}
            setTimeList={setTimeList}
            locations={locations}
            isFavoriteOpen={isFavoriteOpen}
            setIsFavoriteOpen={setIsFavoriteOpen}
            feedbackModalData={feedbackModalData}
            setFeedbackModalData={setFeedbackModalData}
            orderStatusModalData={orderStatusModalData}
            setOrderStatusModalData={setOrderStatusModalData}
            displayComplete={displayComplete}
            setDisplayComplete={setDisplayComplete}
          />
        );
      case 2:
        return (
          <OrderStatus2
            orderStatusList={orderStatusList}
            sendReview={sendReview}
            feedbackModalIsVisible={feedbackModalIsVisible}
            openFeedbackModal={openFeedbackModal}
            closeFeedbackModal={closeFeedbackModal}
            currency={orderStatusList[0].currency}
            is_tip_enabled={is_tip_enabled}
            orderHistory={orderHistory}
            isGuestPlacedOrder={isGuestPlacedOrder}
            placedOrder={placedOrder}
            interOrderType={interOrderType}
            timeList={timeList}
            setTimeList={setTimeList}
            locations={locations}
            isFavoriteOpen={isFavoriteOpen}
            setIsFavoriteOpen={setIsFavoriteOpen}
            feedbackModalData={feedbackModalData}
            setFeedbackModalData={setFeedbackModalData}
            orderStatusModalData={orderStatusModalData}
            setOrderStatusModalData={setOrderStatusModalData}
            displayComplete={displayComplete}
            setDisplayComplete={setDisplayComplete}
          />
        );
      case 3:
        return (
          <OrderStatus3
            orderStatusList={orderStatusList}
            sendReview={sendReview}
            feedbackModalIsVisible={feedbackModalIsVisible}
            openFeedbackModal={openFeedbackModal}
            closeFeedbackModal={closeFeedbackModal}
            currency={orderStatusList[0].currency}
            is_tip_enabled={is_tip_enabled}
            orderHistory={orderHistory}
            isGuestPlacedOrder={isGuestPlacedOrder}
            placedOrder={placedOrder}
            interOrderType={interOrderType}
            timeList={timeList}
            setTimeList={setTimeList}
            locations={locations}
            isFavoriteOpen={isFavoriteOpen}
            setIsFavoriteOpen={setIsFavoriteOpen}
            feedbackModalData={feedbackModalData}
            setFeedbackModalData={setFeedbackModalData}
            orderStatusModalData={orderStatusModalData}
            setOrderStatusModalData={setOrderStatusModalData}
            displayComplete={displayComplete}
            setDisplayComplete={setDisplayComplete}
          />
        );
      default:
        return (
          <OrderStatus1
            orderStatusList={orderStatusList}
            sendReview={sendReview}
            feedbackModalIsVisible={feedbackModalIsVisible}
            openFeedbackModal={openFeedbackModal}
            closeFeedbackModal={closeFeedbackModal}
            currency={orderStatusList[0].currency}
            is_tip_enabled={is_tip_enabled}
            orderHistory={orderHistory}
            isGuestPlacedOrder={isGuestPlacedOrder}
            placedOrder={placedOrder}
            interOrderType={interOrderType}
            timeList={timeList}
            setTimeList={setTimeList}
            locations={locations}
            isFavoriteOpen={isFavoriteOpen}
            setIsFavoriteOpen={setIsFavoriteOpen}
            feedbackModalData={feedbackModalData}
            setFeedbackModalData={setFeedbackModalData}
            orderStatusModalData={orderStatusModalData}
            setOrderStatusModalData={setOrderStatusModalData}
            displayComplete={displayComplete}
            setDisplayComplete={setDisplayComplete}
          />
        );
    }
  };

  return orderStatusList.length || isGuestPlacedOrder ? (
    <StatusCardLayout statusCardLayout={appConfig.statusCardLayout} />
  ) : null;
};

const mapStateToProps = (state) => ({
  orderHistory: state.orderHistoryReducer.orderHistory,
  orderStatusList: state.orderStatusReducer.orderStatusList //??
    .filter((order) => order.config_product.length)
    .reduce((acc, orderStatus) => {
      if (
        state.locationsReducer.locations &&
        state.locationsReducer.locations.length
      ) {
        const location = state.locationsReducer.locations.filter(
          (location) => location.id == orderStatus.business_id
        );
        if (location && location.length && location[0].currency) {
          acc.push({ ...orderStatus, currency: location[0].currency });
        } else {
          acc.push({ ...orderStatus, currency: null });
        }
      }
      return acc;
    }, []),
  feedbackModalIsVisible: state.orderStatusReducer.feedbackModalIsVisible,
  orderSettingReducer: state.orderSettingReducer,
  isGuestSession: state.authReducer.isGuestSession,
  cartReducer: state.cartReducer,
  isAuthenticated: state.authReducer.isAuthenticated,
  is_tip_enabled: state.authReducer.appConfig.is_tip_enabled,
  locations: state.locationsReducer.locations,
});

const formatOrderStatus = (orderStatus) => {
  let isFutureOrder = calculateIsFutureOrder(orderStatus);

  return {
    ...orderStatus,
    // status:
    //   orderStatus.order_type === 'delivery' && orderStatus.status === 2
    //     ? 4
    //     : orderStatus.status,
    estimatedTime:
      orderStatus.order_date && orderStatus.estimated_time
        ? calculatePickupTime(
            orderStatus.order_date,
            orderStatus.estimated_time,
            isFutureOrder
          )
        : null,
    isFutureOrder,
    flatProducts: orderStatus.config_product.map((product) => {
      let flatProduct = flattenProduct({
        ...product,
        options: product.options || [],
      });
      flatProduct = {
        ...flatProduct,
        singlePrice: flatProduct.prices[0].price,
        totalPrice: flatProduct.prices[0].price * flatProduct.quantity,
      };
      return {
        ...product,
        flatProduct,
        singlePrice: flatProduct.prices[0].price,
        totalPrice: flatProduct.prices[0].price * flatProduct.quantity,
      };
    }),
  };
};

const orderStatusIsValid = (orderStatus) => {
  if (appConfig.isStaticOrderStatusCard) {
    let isValid = moment(orderStatus.order_date, 'YYYY-MM-DD HH:mm:ss').isAfter(
      moment().subtract(1, 'hour')
    );
    return isValid;
  } else {
    if (
      orderStatus.status === ORDER_REJECTED ||
      orderStatus.status === ORDER_REFUNDED
    ) {
      let isValid = moment(
        orderStatus.order_date,
        'YYYY-MM-DD HH:mm:ss'
      ).isAfter(moment().subtract(1, 'hour'));
      return isValid;
    } else {
      if (orderStatus.is_future_order) {
        if (
          orderStatus.status === ORDER_COMPLETE ||
          orderStatus.status === ORDER_DELIVERED
        ) {
          return moment(orderStatus.order_date, 'YYYY-MM-DD HH:mm:ss').isAfter(
            moment().subtract(1, 'hour')
          );
        } else {
          return moment(orderStatus.order_date, 'YYYY-MM-DD HH:mm:ss').isAfter(
            moment().subtract(3, 'hour')
          );
        }
      } else {
        let readyTime;
        if ('delivery_tracking_url' in orderStatus) {
          readyTime = orderStatus.order_date;
        } else {
          const prepTimeInMilSeconds = new Date(
            '1970-01-01T' + orderStatus.min_prep_time + 'Z'
          ).getTime();
          const orderTime = new Date(
            moment(orderStatus.order_created_at, 'YYYY-MM-DD HH:mm:ss')
          );

          readyTime = new Date(orderTime.getTime() + prepTimeInMilSeconds);
        }

        if (
          orderStatus.status === ORDER_COMPLETE ||
          orderStatus.status === ORDER_DELIVERED
        ) {
          const momentTime = moment(readyTime).diff(
            moment().subtract(1, 'hour'),
            'minutes'
          );
          return momentTime >= 0 && !!momentTime;
        } else {
          const momentTime = moment(readyTime).diff(
            moment().subtract(3, 'hour'),
            'minutes'
          );

          return momentTime >= 0 && !!momentTime;
        }
      }
    }
  }
};

const orderStatusIsValidNoFirebase = (orderStatus) => {
  const orderTime = new Date(
    moment(orderStatus.order_created_at, 'YYYY-MM-DD HH:mm:ss')
  );
  const readyTime = new Date(orderTime.getTime());
  const momentTime = moment(readyTime).diff(
    moment().subtract(3, 'hour'),
    'minutes'
  );

  return momentTime >= 0 && !!momentTime;
};

const calculatePickupTime = (date, estimatedTime, isFutureOrder) => {
  const estimatedTimeArray = estimatedTime.split(':');
  const hours = parseInt(estimatedTimeArray[0]);
  const minutes = parseInt(estimatedTimeArray[1]);
  const seconds = parseInt(estimatedTimeArray[2]);

  const estimatedMinutes = hours * 60 + minutes + seconds / 60;

  let ret = moment(date, 'YYYY-MM-DD HH:mm:ss');

  // if future ordering, don't add estimate
  if (!isFutureOrder) {
    ret.add(estimatedMinutes, 'minutes');
  }

  return ret;
};

const calculateIsFutureOrder = (orderStatus) => {
  return (
    moment(orderStatus.order_date, 'YYYY-MM-DD HH:mm:ss').diff(
      moment(orderStatus.order_created_at, 'YYYY-MM-DD HH:mm:ss'),
      'seconds'
    ) > 10
  );
};

OrderStatusContainer = withFirebase(OrderStatusContainer);

export default connect(mapStateToProps, actions)(OrderStatusContainer);
